import React, { useState } from 'react';
import styles from '../styles/ArrivalModal.module.css'; 

const warehouses = [
  'Основной склад',
  'На Алиханова',
  'Склад 2'
];

const ArrivalModal = ({ onClose, onSelect }) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>Приемка</h2>
          <button className={styles.close} onClick={onClose}>×</button>
        </div>

        <div className={styles.body}>
          <p className={styles.label}>Выберите склад:</p>
          <ul className={styles.list}>
            {warehouses.map((warehouse, index) => (
              <li key={index} className={styles.item}>
                <label className={styles.radioLabel}>
                  <input
                    type="radio"
                    name="warehouse"
                    checked={selectedWarehouse === warehouse}
                    onChange={() => setSelectedWarehouse(warehouse)}
                  />
                  <span className={styles.customRadio}></span>
                  {warehouse}
                </label>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.footer}>
          <button className={styles.cancel} onClick={onClose}>Отмена</button>
          <button
            className={styles.select}
            onClick={() => onSelect(selectedWarehouse)}
            disabled={!selectedWarehouse}
          >
            Выбрать
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArrivalModal;
